import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query StatementItems($walletId: String!, $cursor: String) {
    statementItems(walletId: $walletId, cursor: $cursor) {
      cursor
      results {
        uuid
        transactionId
        transactionType
        transfer {
          uuid
          amount
          currency
          createdAt
          type
          message
          destinationIds
          rewardedUsers {
            firstName
            lastName
          }
          spend {
            dealHeader
            dealThumbnailImage
            orderTotal {
              currency
              value
            }
            redemptionUuid
          }
          sourceUser {
            firstName
            lastName
            email
          }
          walletType
        }
      }
    }
  }
`

export const statementItemsQueryKey = getQueryNames(query)[0]

export default query
